import { AsyncStorage } from 'AsyncStorage';

export const randomString = (i) => {
  let rnd = '';
  while (rnd.length < i)
    rnd += Math.random().toString(36).substring(2);
  return rnd.substring(0, i);
};

const checkUserId = async () => {
  if(!await AsyncStorage.getItem('userId'))
    await AsyncStorage.setItem('userId', randomString(32));
}

export const getUserId = async () => {
  await checkUserId();
  return await AsyncStorage.getItem('userId')
}

export default checkUserId
